import { colorDecode } from "./colorDecode";
import { Buffer } from "buffer";
import "../SideBarLeft/guild/topGuilds.scss";

const GuildMarker = ({ mark, size = 30 }) => {
  if (!mark) {
    return;
  }

  return (
    <div id="GuildMark" style={{ width: size, height: size }}>
      {new Buffer(mark, "hex")
        .toString("hex")
        .split("")
        .map((symbol, i) => (
          <div
            key={i}
            style={{
              width: size / 8,
              height: size / 8,
              background: colorDecode(symbol),
            }}
            className="cell"
          />
        ))}
    </div>
  );
};

export default GuildMarker;
